import { createUseStyles } from "react-jss";

const ErrorScreen = () => {
  const classes = useStyles();

  return (
    <div className={classes.background}>
      <div>
        <h1>An error occured</h1>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  background: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    backgroundColor: "#313131",
  },
});

export default ErrorScreen;
